(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reports', {
        	abstract: true,
            parent: 'app',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User', 'Customer Users']
            }
        });
    }
})();
